import { render, staticRenderFns } from "./locale-selection.vue?vue&type=template&id=ac3a8ca2&scoped=true&"
import script from "./locale-selection.vue?vue&type=script&lang=js&"
export * from "./locale-selection.vue?vue&type=script&lang=js&"
import style0 from "./locale-selection.vue?vue&type=style&index=0&id=ac3a8ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3a8ca2",
  null
  
)

export default component.exports